import React from 'react';

import type { Apollo } from 'src/gql/generated';
import type { WorkflowStep } from 'src/workflow';
import { ActionRow, getSortedStepActions } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

import { NewActionRow } from './NewActionRow';

const useStyles = makeStyles()(theme => ({
  divider: {
    margin: theme.spacing(0, 2),
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
}));

interface ActionGroupActionListProps {
  hasNewActionRow: boolean;
  setNewActionRow: React.Dispatch<React.SetStateAction<boolean>>;
  step: WorkflowStep;
  workflowId: UUID;
  workflowState: Apollo.WorkflowState;
}

export function ActionGroupActionList({
  hasNewActionRow,
  setNewActionRow,
  step,
  workflowId,
  workflowState,
}: ActionGroupActionListProps): JSX.Element {
  const { classes } = useStyles();
  const sortedActions = getSortedStepActions(step);

  return (
    <div className={classes.list}>
      {sortedActions.map(action => {
        return (
          <ActionRow
            key={action.id}
            action={{ ...action, step }}
            workflowId={workflowId}
            workflowState={workflowState}
          />
        );
      })}
      {hasNewActionRow && (
        <NewActionRow setNewActionRow={setNewActionRow} step={step} workflowId={workflowId} />
      )}
    </div>
  );
}
